export default __webpack_public_path__ + "static/media/Collectibles_page.81c3827d.pdf";